import React from 'react'
import Packages from '../../services/Packages';
import Bubble from '../Bubble/Bubble';
import Skill from '../Skill/Skill';
import "./package.css";

import {motion} from "framer-motion";

export default function Package() {
    return (
        <React.Fragment>
             <motion.div 
            initial={{opacity : 0}}
            exit={{opacity: 0}}
            animate={{opacity : 1}}
        >   

        <Bubble/>

        <h1 className="title">Packages</h1>

        <div className="package-container">
        {
                
            Packages.map( p =>{
               return <div key={p.id} className="package-card">
                <div className="package__header">
                    <div className="package__image">
                        <img className="package__img" src={p.imageUrl} alt="" />
                    </div>
                </div>
                <div className="package__body">
                    <h2 className="package__title">{p.title}</h2>
                    <p className="package__desc">{p.desc}</p>
                </div>
    
                <div className="package__stack">
                    { p.needs.map(need => {
                        return <Skill key={need.id} skill={need.skill} color={need.color}></Skill>
                    }) }
                </div>
    
                <div className="package__footer">
                    <a className="package__link" href={p.npmUrl} rel="noreferrer" target="_blank"><i className="fab fa-npm"></i> NPM</a>
                </div>
            </div>
            })
        }
        </div>
        </motion.div>
        </React.Fragment>
    )
}
